import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Dashboard = namespace('dashboard');

@Component({
    components: { },
})
export default class DashboardView extends Vue {

    public mounted() {
        console.log('dashboard');
    }
}
